import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useConditionalFormattingEntryPoint } from '@atlassian/jira-issue-navigator-action-conditional-formatting/src/controllers/entrypoint-context/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import type { main_issueNavigator_ConditionalFormattingSidebarExperience$key } from '@atlassian/jira-relay/src/__generated__/main_issueNavigator_ConditionalFormattingSidebarExperience.graphql';
import { ErrorState } from '../error-state/index.tsx';

type Props = {
	onClose: () => void;
	project: main_issueNavigator_ConditionalFormattingSidebarExperience$key | null;
};

function ConditionalFormattingSidebarExperience({ onClose, project }: Props) {
	const { entryPointReferenceSubject } = useConditionalFormattingEntryPoint();

	const projectData = useFragment<main_issueNavigator_ConditionalFormattingSidebarExperience$key>(
		graphql`
			fragment main_issueNavigator_ConditionalFormattingSidebarExperience on JiraProject {
				id
			}
		`,
		project,
	);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="conditionalFormattingSidebar"
			packageName="jiraIssueNavigatorActionConditionalFormatting"
			errorFallback={() => <ErrorState onClose={onClose} />}
			teamName="Keystone"
			fallback={<></>}
			runtimeProps={{ message: 'Hello world!', projectId: projectData?.id, onClose }}
		/>
	);
}

export const MaybeConditionalFormattingSidebarExperience = componentWithCondition(
	() => fg('conditional-formatting-new-list-targeting-gate'),
	ConditionalFormattingSidebarExperience,
	() => <></>,
);
